/**
 * Eingabefeld für den Auftragswert – die eine Stelle für dieses Verhalten.
 *
 * Gebraucht wird es an zwei Orten: im Angebot und in der Auftragsübersicht.
 * Beide sollen sich gleich anfühlen und dieselbe Zahl auf dieselbe Weise
 * behandeln, deshalb liegt es hier und nicht zweimal nebeneinander.
 *
 * Bedienung: Enter übernimmt, Escape verwirft, ein Klick nach draußen
 * übernimmt ebenfalls. Ein leeres Feld heißt „nicht erfasst" und wird als
 * null gespeichert – nicht als 0, sonst zählte ein fehlender Wert als Auftrag
 * über null Euro und verfälschte die Summen.
 */

import { useEffect, useRef, useState } from 'react';
import { betragFormatieren, betragLesen } from '../hilfen/format';
import './betragsfeld.css';

export function Betragsfeld({
  wert,
  onSpeichern,
  laeuft = false,
  autoFokus = false,
  onAbbrechen,
}: {
  wert: number | null;
  onSpeichern: (neu: number | null) => void;
  /** Speichern läuft gerade – blockiert weitere Eingaben. */
  laeuft?: boolean;
  autoFokus?: boolean;
  /** Wenn gesetzt, kann das Feld mit Escape geschlossen werden. */
  onAbbrechen?: () => void;
}) {
  const [text, setText] = useState(betragFormatieren(String(wert ?? '')));
  const feld = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFokus) {
      feld.current?.focus();
      feld.current?.select();
    }
  }, [autoFokus]);

  function uebernehmen() {
    const neu = text.trim() === '' ? null : betragLesen(text);
    // Nur schreiben, wenn sich etwas geändert hat – sonst entstünde bei jedem
    // Verlassen des Feldes ein Eintrag in der Chronik.
    if (neu !== wert) onSpeichern(neu);
    else onAbbrechen?.();
  }

  return (
    <span className="betragsfeld">
      <input
        ref={feld}
        inputMode="decimal"
        disabled={laeuft}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={uebernehmen}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            uebernehmen();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            setText(betragFormatieren(String(wert ?? '')));
            onAbbrechen?.();
          }
        }}
      />
      <span className="betragsfeld-waehrung">€</span>
    </span>
  );
}